import { useLocation } from "react-router-dom";

/**
 *
 * @returns Hook to use language. Includes language and languagePath components
 */
export function useCurrentLanguage() {
  const location = useLocation();
  let locationPaths = location.pathname.split("/");

  let language, languagePath;

  if (locationPaths.includes("en")) {
    language = "en";
    languagePath = "/en";
  } else if (locationPaths.includes("es")) {
    languagePath = "/es";
    language = "es";
  } else {
    language = "es";
    languagePath = "";
  }

  return {
    language: language,
    languagePath: languagePath,
  };
}
